var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 8.00042C18.0003 8.19933 17.9213 8.3901 17.7807 8.53075C17.64 8.6714 17.4493 8.75042 17.2503 8.75042H2.56066L8.03097 14.2198C8.10065 14.2895 8.15593 14.3722 8.19364 14.4632C8.23135 14.5543 8.25076 14.6519 8.25076 14.7504C8.25076 14.849 8.23135 14.9465 8.19364 15.0376C8.15593 15.1286 8.10065 15.2114 8.03097 15.281C7.96129 15.3507 7.87856 15.406 7.78752 15.4437C7.69647 15.4814 7.59889 15.5008 7.50035 15.5008C7.4018 15.5008 7.30422 15.4814 7.21317 15.4437C7.12213 15.406 7.0394 15.3507 6.96972 15.281L0.219721 8.53104C0.149988 8.46139 0.0946693 8.37867 0.0569261 8.28762C0.0191829 8.19657 -0.000244141 8.09898 -0.000244141 8.00042C-0.000244141 7.90186 0.0191829 7.80426 0.0569261 7.71321C0.0946693 7.62216 0.149988 7.53945 0.219721 7.46979L6.96972 0.719792C7.11045 0.579062 7.30132 0.5 7.50035 0.5C7.69937 0.5 7.89024 0.579062 8.03097 0.719792C8.1717 0.860523 8.25076 1.05139 8.25076 1.25042C8.25076 1.44944 8.1717 1.64031 8.03097 1.78104L2.56066 7.25042H17.2503C17.4493 7.25042 17.64 7.32943 17.7807 7.47009C17.9213 7.61074 18.0003 7.8015 18.0003 8.00042Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.d8d3b9b815d352b3435db27f9311f3fd.svg";
export { ForwardRef as ReactComponent };